import React from 'react';

function OIcon(props: { className?: string }) {
    return (
        <div
            className={`flex items-center justify-center rounded-full bg-gradient-to-tr from-orange-500 to-amber-200 ${props.className ?? ''}`}
        >
            <div className="h-1/3 w-1/3 rounded-full bg-white"></div>
        </div>
    );
}

export default OIcon;
